<div class="no_access_container">
  <img [src]="path" alt="No Data" />
  <p>
    {{ msg }}<br/>
    Please contact your Administrator for the access
  </p>
</div>
